import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import CryptoJS from 'crypto-js'
import Authorization from '../../../../types/Authorization'
import Provider from '../../../../types/Provider'
import ActionData from '../../../../types/ActionData'
import RootState from '../../../../types/RootState'
import User from '../../../../types/User'
import moment from 'moment'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import AuthorizationDetailModal from '../../../../components/Modals/AuthorizationDetailModal'
import DatePicker from 'react-datepicker'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Accordion, Button, Card, Col, Form, /*Nav,*/ Row/*, Tab*/ } from 'react-bootstrap'
import { formatDate, formatPhoneNumber, convert } from '../../../../utils/dataTools'
import { getAuthorizations } from '../../../../redux/actions/authorization'
import { addUserActivity } from '../../../../redux/actions/authentication'
import { CSVLink } from 'react-csv'
import './index.css'
import { truncate, formatNoUTCDate, formatUTCDate } from '../../../../utils/stringTools'

interface Props {
  authorizations: Array<Authorization>;
  authorizationsData: ActionData;
  authorizationsPagination: {
    sizePerPage: number;
    totalSize: number;
  };
  csvAuthorizations: ActionData;
  height: number;
  selectedProvider: Provider;
  user: User;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number; authorizationId?: number }, token: string ) => void;
  getAuthorizations: (id: number, page: number, sizePerPage: number, searchTerm: string, startDate: string, endDate: string, filterByAuthStatus: string, sortField: string, sortOrder: string, endDateFrom: string, endDaTeTo: string, type: string, token: string) => void;
  onSelectServiceCode: (serviceCode: string) => void;
}

class Authorizations extends Component<Props> {
  private csvLink: any = createRef()

  state = {
    //Search
    endDate: undefined,
    searchOpen: false,
    startDate: undefined,
    endDateFrom: undefined,
    endDateTo: undefined,
    searchTerm: '',
    //Filter
    filterByAuthStatus: 'all',
    //Authorizations
    selectedAuthorization: {
      lastStatusChangeDate: '',
      authorizationId: -1,
      authorizationNumber: '',
      authorizationStartDate: '',
      authorizationEndDate: '',
      authDetails: '',
      careManager: '',
      careManagerPhone: '',
      currentStatus: '',
      tcFrequency: '',
      memberId: -1,
      memberName: '',
      memberMci: '',
      memberSsn: '',
      memberDob: '',
      procedureName: '',
      serviceCategory: '',
      revisionIndicator: '',
      rn: '',
      rnPhone: '',
      tcUnitsPerFrequency: -1,
      serviceCode: '',
      tcTotalUnits: 0,
      tcCostOverride: 0,
      tcNegotiatedRate: 0
    },
    show: false,
    page: 1,
    totalSize: 0,
    sortField: null,
    sortOrder: null
  }

  componentDidMount() {
    const { authorizationsPagination, selectedProvider, getAuthorizations } = this.props

    if (selectedProvider.provider_id !== -1) {
      let token
      if (localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined') {
        token = JSON.parse(localStorage.getItem('token') || '')
        getAuthorizations(selectedProvider.provider_id, 1, authorizationsPagination.sizePerPage, null, null, null, null, null, null, null, null, 'PAGING', token)
        this.setState({ page: 1 })
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { authorizationsPagination, csvAuthorizations, selectedProvider, getAuthorizations } = this.props
    if (selectedProvider !== prevProps.selectedProvider) {
      let token
      if (localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined') {
        token = JSON.parse(localStorage.getItem('token') || '')
        getAuthorizations(selectedProvider.provider_id, 1, authorizationsPagination.sizePerPage, null, null, null, null, null, null, null, null, 'PAGING', token)
        this.setState({ page: 1 })
      }
    }

    if ( authorizationsPagination !== prevProps.authorizationsPagination ) {
      this.setState({ totalSize: authorizationsPagination.totalSize })
    }

    if ( csvAuthorizations !== prevProps.csvAuthorizations ) {
      if (csvAuthorizations.data && this.csvLink.current && this.csvLink.current.link) {
        setTimeout(() => {
          this.csvLink.current.link.click()
        })
      }
    }
  }

  applyFilters = () => {
    const { selectedProvider, authorizationsPagination, getAuthorizations } = this.props
    const { startDate, endDate, searchTerm, filterByAuthStatus, sortField, sortOrder, endDateFrom, endDateTo } = this.state
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    getAuthorizations(selectedProvider.provider_id, 1, authorizationsPagination.sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'PAGING', token)
    this.setState({ page: 1 })
  }

  clearFilters = () => {
    const { sortField, sortOrder } = this.state
    const { selectedProvider, authorizationsPagination, getAuthorizations } = this.props
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    getAuthorizations(selectedProvider.provider_id, 1, authorizationsPagination.sizePerPage, null, null, null, null, sortField, sortOrder, null, null, 'PAGING', token)
    this.setState({
      endDate: undefined,
      searchTerm: '',
      startDate: undefined,
      filterByAuthStatus: 'all',
      page: 1
    })
  }

  closeModal = () => {
    this.setState({
      selectedAuthorization: {
        lastStatusChangeDate: '',
        authorizationId: -1,
        authorizationNumber: '',
        authorizationStartDate: '',
        authorizationEndDate: '',
        careManager: '',
        currentStatus: '',
        tcFrequency: '',
        memberId: -1,
        memberName: '',
        memberMci: '',
        memberSsn: '',
        procedureName: '',
        serviceCategory: '',
        revisionIndicator: '',
        rn: '',
        tcUnitsPerFrequency: -1,
        serviceCode: '',
        tcTotalUnits: 0,
        tcCostOverride: 0,
        tcNegotiatedRate: 0
      },
      show: false
    })
  }

  formatAuthDataForCSV = (authorizations: Array<Authorization>, provider: Provider) => {
    const data = authorizations
    if (!data || data === undefined || data.length === 0) {
      return []
    }
    const csv = data.map(auth => ({
      'Member ID': auth.memberId,
      'Member Name': auth.memberName,
      'Member DOB': formatUTCDate(auth.memberDob),
      'MCI': auth.memberMci,
      'SSN': auth.memberSsn,
      'Care Manager': auth.careManager,
      'Care Manager Phone': formatPhoneNumber(auth.careManagerPhone),
      'RN': auth.rn,
      'RN Phone': formatPhoneNumber(auth.rnPhone),
      'Auth No': auth.authorizationNumber,
      'Entered On Date': formatNoUTCDate(truncate(10, auth.lastStatusChangeDate)),
      'Service Code': auth.serviceCode,
      'Service Type': auth.serviceCategory,
      'Procedure': auth.procedureName,
      'Service Provider': provider.provider_name,
      'Provider Address': provider.address_1 + ' ' + provider.address_2 + ', ' + provider.city + ', ' + provider.state + ' ' + provider.zip_code,
      'Provider Phone': formatPhoneNumber(provider.phone),
      'Service Start Date': formatNoUTCDate(formatDate(auth.authorizationStartDate)),
      'Service End Date': formatNoUTCDate(formatDate(auth.authorizationEndDate)),
      'Units': auth.tcUnitsPerFrequency,
      'Frequency': auth.tcFrequency,
      'Total Units': auth.tcTotalUnits,
      'Unit Rate': auth.tcCostOverride !== null && auth.tcCostOverride !== undefined ? auth.tcCostOverride : ( auth.tcNegotiatedRate !== null && auth.tcNegotiatedRate !== undefined ? auth.tcNegotiatedRate : 'See Contracted Rates' ),
      'Status': auth.currentStatus,
      'Auth Status': auth.revisionIndicator === 'C' ? 'VOID' : (moment(moment(formatDate(auth.authorizationEndDate))).isSameOrAfter(moment()) ? 'OPEN' : 'CLOSED'),
      'Cancel Auth': auth.revisionIndicator === 'C' ? 'Yes' : 'No',
      'Revised': auth.revisionIndicator === '1' ? 'Yes' : 'No',
      'Details': auth.authDetails ? auth.authDetails.replace(/(?:\r\n|\r|\n)/g, ' ').replace('"', '""') : ''
    }))
    return csv
  }

  handleChangeDate = (date: Date, name: string) => {
    this.setState({
      [name]: date
    })
  }

  handleChangeString = (evt: any) => {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  handleDownloadPdf = () => {
    const input = document.getElementById('downloadPdf')
    if (input !== null) {
      input.style.width = '700px'

      html2canvas(input)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png')

          const pdf = new jsPDF()
          pdf.addImage(imgData, 'PNG', 10, 10, canvas.width, canvas.height)
          pdf.save('authorization.pdf')

          input.style.width = '75%'
        })
    }
  }

  handleSearchIconClicked = () => {
    this.setState({
      searchOpen: !this.state.searchOpen
    })
  }

  openModal = (row: any, show: boolean) => {
    const { user, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    this.setState({
      selectedAuthorization: row,
      show
    })

    addUserActivity({
      eid: email.eid,
      activity: 'View Authorization',
      authorizationId: row.authorizationId,
    }, token)
  }

  handlePageChange = (page, sizePerPage) => {
    const { selectedProvider, getAuthorizations } = this.props
    const { startDate, endDate, searchTerm, filterByAuthStatus, sortField, sortOrder, endDateFrom, endDateTo } = this.state
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    this.setState({ page })
    getAuthorizations(selectedProvider.provider_id, page, sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'PAGING', token)
  }
  
  handleTableChange = (type, { sortField, sortOrder }) => {
    // handle any data change here
    if ( type === 'sort') {
      const { authorizationsPagination, selectedProvider, getAuthorizations } = this.props
      const { startDate, endDate, searchTerm, filterByAuthStatus, page, endDateFrom, endDateTo } = this.state
      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
      
      this.setState({ sortField, sortOrder })
      getAuthorizations(selectedProvider.provider_id, page, authorizationsPagination.sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'PAGING', token)
    }
  }

  handleDownloadActivity = () => {
    const { selectedProvider, authorizationsPagination, user, addUserActivity, getAuthorizations } = this.props
    const { startDate, endDate, searchTerm, filterByAuthStatus, sortField, sortOrder, endDateFrom, endDateTo } = this.state
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    getAuthorizations(selectedProvider.provider_id, 1, authorizationsPagination.sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'CSV', token)
    addUserActivity({
      eid: email.eid,
      activity: 'Download Authorizations',
      providerId: selectedProvider.provider_id
    }, token)
  }

  render() {
    const { endDate, filterByAuthStatus, selectedAuthorization, show, startDate, searchTerm, totalSize, page, endDateFrom, endDateTo } = this.state
    const { authorizations, height, selectedProvider, authorizationsData, authorizationsPagination, csvAuthorizations, onSelectServiceCode } = this.props

    const columns = [{
      dataField: 'authorizationNumber',
      text: 'Auth No',
      sort: true
    }, {
      dataField: 'memberName',
      text: 'Member Name',
      sort: true,
      formatter: (cellContent) => cellContent.trim() !== ',' ? cellContent : ''
    }, {
      dataField: 'serviceCode',
      text: 'Service Code',
      sort: true
    }, {
      dataField: 'procedureName',
      text: 'Procedure',
      sort: true,
      formatter: (cellContent) => {
        return (
          <div className='serviceCode' onClick={() => onSelectServiceCode(cellContent)}>
            {cellContent}
          </div>
        )
      }
    }, {
      dataField: 'authorizationStartDate',
      text: 'Service Start',
      sort: true,
      formatter: (cellContent) => {
        return (
          formatNoUTCDate(formatDate(cellContent))
        )
      }
    }, {
      dataField: 'authorizationEndDate',
      text: 'Service End',
      sort: true,
      formatter: (cellContent) => {
        return (
          formatNoUTCDate(formatDate(cellContent))
        )
      }
    }, {
      dataField: 'lastStatusChangeDate',
      text: 'Entered On Date',
      sort: true,
      formatter: (cellContent) => formatNoUTCDate(truncate(10, cellContent))
    }, {
      dataField: 'revisionIndicator',
      text: 'Revised',
      sort: true,
      formatter: (cellContent) => cellContent === '1' ? 'Yes' : 'No'
    }, {
      dataField: 'authStatus',
      text: 'Auth Status',
      sort: true,
      formatter: (cellContent, row) => row.revisionIndicator === 'C' ? 'VOID' : (moment(moment(formatDate(row.authorizationEndDate))).isSameOrAfter(moment()) ? 'OPEN' : 'CLOSED')
    }]

    const rowEvents = {
      onClick: (e, row) => {
        if (e.target.tagName !== 'DIV') {
          this.openModal(row, true)
        }
      }
    }

    let data = <div>No Authorizations available</div>

    if (authorizationsData.loading === true)
      data = (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
          <CircularProgress size={40} />
          <span>Loading data</span>
        </div>
      )

    const csvData = this.formatAuthDataForCSV(csvAuthorizations.data, selectedProvider)
    return (
      <div>
        <Accordion style={{ marginBottom: 20, borderBottom: '1px solid rgba(0, 0, 0, 0.125)' }} defaultActiveKey='0'>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant='link' eventKey='0'>
                Search Authorizations
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey='0'>
              <Card.Body>
                <Row>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Authorizations Active Between</Form.Label>
                      <DatePicker
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(date: Date) => this.handleChangeDate(date, 'startDate')}
                        className='datepicker'
                        placeholderText='Auth Started On/After'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <div style={{ height: '2rem' }} />
                      <DatePicker
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(date: Date) => this.handleChangeDate(date, 'endDate')}
                        minDate={startDate}
                        className='datepicker'
                        placeholderText='Auth Ended On/Before'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Member Name, Procedure, or Authorization No.</Form.Label>
                      <Form.Control
                        placeholder='Enter Member Name, Procedure, or Authorization No.'
                        aria-label='Enter Member Name, Procedure, or Authorization No.'
                        name='searchTerm'
                        value={searchTerm}
                        onChange={this.handleChangeString}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Authorization Start Date</Form.Label>
                      <Form.Label></Form.Label>
                      <DatePicker
                        selected={endDateFrom}
                        selectsStart
                        startDate={endDateFrom}
                        endDate={endDateTo}
                        onChange={(date: Date) => this.handleChangeDate(date, 'endDateFrom')}
                        className='datepicker'
                        placeholderText='Start Range'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <div style={{ height: '2rem' }} />
                      <DatePicker
                        selected={endDateTo}
                        selectsEnd
                        startDate={endDateFrom}
                        endDate={endDateTo}
                        onChange={(date: Date) => this.handleChangeDate(date, 'endDateTo')}
                        minDate={endDateFrom}
                        className='datepicker'
                        placeholderText='End Range'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Authorization Status</Form.Label>
                      <Form.Control as='select' name='filterByAuthStatus' value={filterByAuthStatus} onChange={this.handleChangeString}>
                        <option value='all'>ALL</option>
                        <option value='open'>OPEN</option>
                        <option value='closed'>CLOSED</option>
                        <option value='void'>VOID</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 2, offset: 8 }}>
                    <Button variant='outline-secondary' block onClick={this.clearFilters} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block' }}>Clear</Button>
                  </Col>
                  <Col xs={2}>
                    <Button variant='success' block onClick={() => { this.applyFilters() }} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block' }}>Search</Button>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <div style={{ height: height - 357 }}>
          <PaginationProvider
            pagination={paginationFactory({
              custom: true,
              page: page,
              totalSize: totalSize,
              sizePerPage: authorizationsPagination.sizePerPage,
              onPageChange: this.handlePageChange
            })}
          >
            {
              ({
                paginationProps,
                paginationTableProps,
              }) => (
                <div>
                  <ToolkitProvider
                    keyField='authorizationId'
                    bootstrap4
                    data={authorizations}
                    columns={columns}
                    search
                  >
                    {
                      props => (
                        <div className='authorizations-table-container' style={{ width: '100%' }}>
                          {
                            csvAuthorizations.loading ? (
                              <div style={{ float: 'right', paddingBottom: 10 }}>
                                <Button variant='success' disabled>
                                  <div>Downloading <CircularProgress size={10} style={{ marginLeft: 10, color: 'white' }} /></div>
                                </Button>
                              </div>
                            ) :
                              csvData.length > 0 ? (
                                <CSVLink ref={this.csvLink} data={csvData} filename={`${selectedProvider.provider_name}_Authorizations_${moment().format('YYYY-MM-DD')}.csv`} style={{ float: 'right', paddingBottom: 10 }}>
                                  <Button variant='success' >
                                    Download
                                  </Button>
                                </CSVLink>
                              ) : (
                                <div style={{ float: 'right', paddingBottom: 10 }}>
                                  <Button variant='success' onClick={this.handleDownloadActivity}>
                                    Download
                                  </Button>
                                </div>
                              )
                          }
                          <BootstrapTable
                            id='authorizations_table'
                            bordered={false}
                            remote
                            striped
                            condensed
                            bootstrap4
                            rowEvents={rowEvents}
                            noDataIndication={() => (data)}
                            onTableChange={this.handleTableChange}
                            {...paginationTableProps}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                  <PaginationTotalStandalone {...paginationProps} />
                  <PaginationListStandalone
                    {...paginationProps}
                  />
                </div>
              )
            }
          </PaginationProvider>
        </div>
        <AuthorizationDetailModal
          isOrganization={false}
          authorization={selectedAuthorization}
          provider={selectedProvider}
          show={show}
          onClose={this.closeModal}
          onDownloadPdf={this.handleDownloadPdf}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  authorizations: state.authorization.authorizations.data,
  authorizationsData: state.authorization.authorizations,
  csvAuthorizations: state.authorization.csvAuthorizations,
  authorizationsPagination: state.authorization.authorizations.pagination,
  user: state.authentication.user.data,
})

const mapDispatchToProps = {
  addUserActivity,
  getAuthorizations
}

export default connect(mapStateToProps, mapDispatchToProps)(Authorizations)
